module.exports = __webpack_public_path__ + "resource/img/notification.4aa30b95.svg";